import { useCart } from '@corratech/pylot-cart-manager'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useTrackCheckoutStep } from '@components/OOKA/pylot-tag-manager/src/hooks/useTrackCheckoutStep'
import { CheckoutStepNameEnum } from 'config'
import { CHECKOUT_PAGE_ROUTE } from '@components/OOKA/pylot-tag-manager/src/TrackCheckoutSteps/useTrackCheckoutPageStep'
import { parseUrlPathName } from '@corratech/pylot-tag-manager/src/utils/parseUrlPathName'

export const useTrackPaymentMethod = (): null => {
    const { isFallback, asPath } = useRouter()
    const trackCheckoutStep = useTrackCheckoutStep()
    const { data, isValidating } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart
    const isOptimistic = data?.data?.isOptimistic
    useEffect(() => {
        const methodTitle = cart?.selected_payment_method?.title

        if (
            methodTitle &&
            !isFallback &&
            !isOptimistic &&
            !isValidating &&
            parseUrlPathName(asPath) === CHECKOUT_PAGE_ROUTE
        ) {
            trackCheckoutStep({
                step: CheckoutStepNameEnum.PAYMENT,
                option: methodTitle
            })
        }
    }, [cart, isFallback, isValidating, isOptimistic])

    return null
}
